import { render } from "./Sidebar.vue?vue&type=template&id=33adc67c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=33adc67c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33adc67c"

export default script